// src/app/skip-interceptor.ts
import { HttpContextToken } from '@angular/common/http';

export const SKIP_REGION_CHECK_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
